// components/PopupVendor/VendorWorkersSection.js
import React, {useState} from 'react';

const VendorWorkersSection = ({
                                  isCurrentUserVendorOwner,
                                  workers = [],
                                  handlerShowEditWorkersPopup
                              }) => {
    const [showAllWorkers, setShowAllWorkers] = useState(false);

    if (!isCurrentUserVendorOwner && workers.length === 0) {
        return null;
    }

    const displayedWorkers = showAllWorkers ? workers : workers.slice(0, 2);
    const remainingWorkersCount = workers.length - displayedWorkers.length;


    return (
        <div className="profile__block">
            <div className="container">
                <div className="profile__header"><h2>{workers.length} workers on staff</h2>
                    {isCurrentUserVendorOwner && (
                        <button className="button no-style" onClick={handlerShowEditWorkersPopup}>
                            <img src="/assets/icon--edit-Z9QfuMgm.svg" alt="Edit Workers"/>
                            {(workers.length === 0) ? 'Add Workers' : 'Edit Workers'}
                        </button>
                    )}
                </div>
                <div className="profile__content">
                    <div className="attorneys">
                        <ul className="attorneys__list">
                            {displayedWorkers.map((worker, index) => (
                                <li key={worker.id || index} className="attorney" style={{cursor: 'default'}}>
                                    <div className="attorney__avatar">
                                        <div className="avatar">
                                            <picture>
                                                {worker.photo && (
                                                    <>
                                                        <source type="image/webp" srcSet={worker.photo}/>
                                                        <source type="image/jpg" srcSet={worker.photo}/>
                                                        <img src={worker.photo}
                                                             alt={`${worker.first_name} ${worker.last_name}`}/>
                                                    </>
                                                )}
                                            </picture>
                                        </div>
                                    </div>
                                    <div className="attorney__content">
                                        <div>
                                            <h3 className="attorney__name">{worker.first_name} {worker.last_name}</h3>
                                            <div className="attorney__info">
                                                {worker.positions && worker.positions.length > 0 && (
                                                    <span>{worker.positions.map(position => position.title).join(', ')}</span>
                                                )}
                                            </div>
                                        </div>
                                        <ul className="params__list">
                                            {worker.specializations.slice(0, 5).map((spec, specIndex) => (
                                                <li key={spec.id || specIndex}>{spec.name}</li>
                                            ))}
                                            {worker.specializations.length > 5 && (
                                                <li>+ {worker.specializations.length - 5} more</li>
                                            )}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        {workers.length > 2 && (
                            <div className="show-all">
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    setShowAllWorkers(!showAllWorkers);
                                }}>
                                    {showAllWorkers ? 'Show Less' : `Show More Workers • ${remainingWorkersCount} (${workers.length})`}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorWorkersSection;